import React from "react";
import FirebaseProvider from "./lib/firebase";
import { RoleProvider } from "./lib/userRole";
import Init from "./components/Init";
import Login from "./components/Login";
import Reset from "./components/Reset";
import Register from "./components/Register";
import Employees from "./components/Employees";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { ForceRenderProvider } from "./lib/rerender";

export default function InternalPage() {
  return (
    <FirebaseProvider>
      <RoleProvider>
        <ForceRenderProvider>
          <Router>
            <Routes>
              <Route exact path='/reset' element={<Reset />} />
              <Route exact path='/dashboard/*' element={<Init />} />
              <Route
                exact
                path={"dashboard/employees"}
                element={<Employees />}
              />
              <Route exact path='/' element={<Login />} />
              <Route exact path='/register' element={<Register />} />
            </Routes>
          </Router>
        </ForceRenderProvider>
      </RoleProvider>
    </FirebaseProvider>
  );
}
